{
  "setting_action_row": {
    "edit": "Edit"
  },
  "plan_upgrade_prompt": {
    "available_on_pro": "Available on Pro and Enterprise (and as an addon)",
    "available_on_growth": "Available on Growth, Pro, and Enterprise",
    "change_plan": "Change plan"
  },
  "quoting_migration_modal": {
    "title": "Enable Quotes",
    "alert_title": "These migrations are required for the new Quoting Engine.",
    "docs_link": "Learn more",
    "migration_sparkjs": {
      "title": "Migrate to SparkJS 3.7 or higher",
      "description": "This will set your SparkJS version to at least version 3.7."
    },
    "migration_engine": {
      "title": "Migrate to the new Quoting Engine",
      "description": "Customer groups currently using the \"Request For Quote\" payment method will have it disabled and replaced with the new \"Quoting Engine\"."
    },
    "additional_info": "Please ensure you have updated your SparkLayer Core Script.",
    "migrate_and_enable": "Migrate and Enable",
    "close": "Close"
  },
  "custom_email_domain_modal": {
    "title": "Edit Custom Email Domain",
    "description": "Customise the user and domain used for outbound and inbound emails.",
    "toggle": {
      "label": "Enable Custom Email Domain",
      "description": "Use your custom domain for emails sent to/from SparkLayer"
    },
    "fields": {
      "user": {
        "label": "Email User",
        "placeholder": "no-reply"
      },
      "domain": {
        "label": "Domain",
        "placeholder": "mail.sparklayer.io"
      }
    },
    "update_settings": "Update Settings"
  }
}
